<template>
   <div>
    <div class="container">
        <div class="shimmer image-icon"></div>
        <div class="bars">
            <div class="shimmer bar">
            </div>
            <div class="shimmer bar">         
            </div>
        </div>
    </div>
    <div class="container">
        <div class="shimmer image-icon"></div>
        <div class="bars">
            <div class="shimmer  bar">
            </div>
            <div class="shimmer bar">         
            </div>
        </div>
    </div><div class="container">
        <div class="shimmer image-icon"></div>
        <div class="bars">
            <div class="shimmer bar">
            </div>
            <div class="shimmer bar">         
            </div>
        </div>
    </div><div class="container">
        <div class="shimmer image-icon"></div>
        <div class="bars">
            <div class="shimmer bar">
            </div>
            <div class="shimmer bar">         
            </div>
        </div>
    </div>
    </div>
</template>
<script>


export default {
    name: 'ShimmerCards',
}
</script>
<style lang="scss" scoped>
.container {
    width: 328px;
    display: flex;
    height: 90px;
    margin-top: 24px;
    margin-bottom: 10px;

    .shimmer {
        animation : shimmer 4s infinite linear;
        background: linear-gradient(to bottom right, #eff1f3 4%, #e2e2e2 25%, #eff1f3 36%);
        background-size: 800px 100px;
    }

    .image-icon {
        width: 90px;
        height: 90px;
        background-color: #DDDFE1;  
        opacity: 0.6;
    }
    .bars {
        margin-left: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .bar {
            height: 20px;
            width: 200px;
            background-color: #DDDFE1;  
            opacity: 0.6;  
        }
    }

}



@keyframes shimmer {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0px;
    }

}
</style>

